import { useVinSessionState } from '@web/vin-sessions/context/vin-sessions.hooks';

import { Ssm5LastConnection } from './ssm5-last-connection';
import { Ssm5SessionRecentConnection } from './ssm5-session-recent-connection';

/**
 * The Recent connections section of the SSM5 page: the open VIN session's most recent SSM5
 * connection, or the technician's most recent one when no VIN session is open.
 *
 * @returns the section for the current mode
 */
export function Ssm5RecentConnections() {
    const { selectedVin } = useVinSessionState();

    return selectedVin ? <Ssm5SessionRecentConnection vehicle={selectedVin} /> : <Ssm5LastConnection />;
}
